import {CurrentUserPermissions} from "../../AppState";

export const defaultCurrentUserPermissions: CurrentUserPermissions  = {
    "CanShowClinicAdminSetup": false,
    "CanShowInvitation": false,
    "CanShowRolePermissionSubscription": false,
    "CanShowNotification": false,
    "CanShowClientInvitationStatus": false,
    "CanShowUserInvitationStatus": false,
    "CanShowPortal": false,
    "CanShowInvitationStatus": false,
    "CanViewSiteSearch": false,
    "CanViewOrder": false,
    "CanViewTracking": false,
    "CanViewCompleted": false,
    "CanInviteClientUser": false,
    "CanManageClient": false,
    "CanCreateClient": false,
    "CanCreateInstance": false,
    "CanEditPendingOrders": false,
    "CanViewRandomTesting": false,
    "CanManageClientUser": false,
    "CanManageInstanceUser": false,
    "CanViewPersonnel": false,
    "CanViewOrderTrackingGrid": false,
    "CanManageServiceEvent": false,
    "CanVieweCCFCopy2PreMRO": false,
    "CanViewOrderSummary": false,
    "CanManagePersonnel": false,
    "CanManagePools": false,
    "CanCompleteEvents": false,
    "CanUploadImages": false,
    "CanViewAddressAlert": false,
    "CanSearchDefaults": false,
    "CanGroupInclude": false,
    "CanManageOrphanResults": false,
    "CanEditPersonnel": false,
    "CanManageSelectionInbox": false,
    "CanManageGovDonors": false,
    "CanManageGovPools": false,
    "CanManageConsortiumPools": false,
    "CanOrderGovServices": false,
    "CanViewMISReports": false,
    "CanMergeTests": false,
    "CanMatchTests": false
}
